<template>
  <div class="section">
    <div class="tab-title">{{ $t('Sop.SopFilterContent.SopFilterConditionsTip') }}</div>
    {{ $t('Sop.SopFilterContent.BusinessState') }}
    <div class="checkbox-group">
      <el-checkbox-group v-model="jobState" @change="handleCheckedJobStateChange">
        <el-checkbox v-for="(item) in jobs" :key="item.key" :label="item.key">{{ item.value }}</el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="date-wrapper">
      {{ $t('Sop.SopFilterContent.Date') }}
      <div><span>{{ $t('Sop.SeaExport') }}：{{ $t('Sop.SopFilterContent.ETD') }}</span><el-input v-model.number="seExpireDays" maxlength="2" oninput="value=value.replace(/[^0-9.]/g,'')" />{{ $t('Sop.SopFilterContent.Days') }}</div>
      <div><span>{{ $t('Sop.SeaImport') }}：{{ $t('Sop.SopFilterContent.ETA') }}</span><el-input v-model.number="siExpireDays" maxlength="2" oninput="value=value.replace(/[^0-9.]/g,'')" />{{ $t('Sop.SopFilterContent.Days') }}</div>
      <div><span>{{ $t('Sop.AirExport') }}：{{ $t('Sop.SopFilterContent.ETD') }}</span><el-input v-model.number="aeExpireDays" maxlength="2" oninput="value=value.replace(/[^0-9.]/g,'')" />{{ $t('Sop.SopFilterContent.Days') }}</div>
      <div><span>{{ $t('Sop.AirImport') }}：{{ $t('Sop.SopFilterContent.ETA') }}</span><el-input v-model.number="aiExpireDays" maxlength="2" oninput="value=value.replace(/[^0-9.]/g,'')" />{{ $t('Sop.SopFilterContent.Days') }}</div>
      <div><span>{{ $t('Sop.RailwayExport') }}：{{ $t('Sop.SopFilterContent.ETD') }}</span><el-input v-model.number="reExpireDays" maxlength="2" oninput="value=value.replace(/[^0-9.]/g,'')" />{{ $t('Sop.SopFilterContent.Days') }}</div>
      <div><span>{{ $t('Sop.RailwayImport') }}：{{ $t('Sop.SopFilterContent.ETA') }}</span><el-input v-model.number="riExpireDays" maxlength="2" oninput="value=value.replace(/[^0-9.]/g,'')" />{{ $t('Sop.SopFilterContent.Days') }}</div>
      <div><span>{{ $t('Sop.IntegratedJob') }}：{{ $t('Sop.SopFilterContent.ETD') }}</span><el-input v-model.number="integratedDays" maxlength="2" oninput="value=value.replace(/[^0-9.]/g,'')" />{{ $t('Sop.SopFilterContent.Days') }}</div>
    </div>
  </div>
</template>
<script>
import { postSopFilterConfig, getSopFilterConfig } from '@/api/sop'
export default {
  data() {
    return {
      checkAll: false,
      jobState: [0],
      jobs: [{
        value: this.$t('CargoMsg.Cargo_HoldSubmission'),
        key: -2 // 远程订舱-暂不提交
      }, {
        value: this.$t('CargoMsg.Cargo_PendingPrice'),
        key: -1 // 订舱预审-待审核
      }, {
        value: this.$t('Sop.SopFilterContent.Operation'),
        key: 0
      }, {
        value: this.$t('Sop.SopFilterContent.PreCommit'),
        key: 11
      }, {
        value: this.$t('Sop.SopFilterContent.Submit'),
        key: 1
      }, {
        value: this.$t('Sop.SopFilterContent.Audit'),
        key: 2
      }],
      checkedDate: true,
      seExpireDays: 60,
      siExpireDays: 60,
      aeExpireDays: 30,
      aiExpireDays: 30,
      reExpireDays: 60,
      riExpireDays: 60,
      integratedDays: 30
    }
  },
  created() {
    this.getSopFilterConfig()
  },
  methods: {
    async getSopFilterConfig() {
      const res = await getSopFilterConfig()
      const data = res.data
      let jobState = data.jobState
      const { reExpireDays, seExpireDays, siExpireDays, aiExpireDays, aeExpireDays, integratedDays, riExpireDays } = data
      jobState = jobState === '' ? [] : jobState.split(',')
      this.jobState = jobState.map(item => {
        return Number(item)
      })
      this.reExpireDays = reExpireDays
      this.seExpireDays = seExpireDays
      this.siExpireDays = siExpireDays
      this.aiExpireDays = aiExpireDays
      this.aeExpireDays = aeExpireDays
      this.integratedDays = integratedDays
      this.riExpireDays = riExpireDays
    },
    handleCheckedJobStateChange(value) {
      const checkCount = value.length
      this.checkAll = checkCount === this.jobs.length
      this.isIndeterminate = checkCount > 0 && checkCount < this.jobs.length
      console.log(this.jobState)
    },
    async postSopFilterConfig() {
      const jobState = this.jobState.join(',')
      const { seExpireDays, aeExpireDays, aiExpireDays, siExpireDays, reExpireDays, integratedDays, riExpireDays } = this
      const data = {
        jobState,
        seExpireDays,
        aeExpireDays,
        aiExpireDays,
        siExpireDays,
        reExpireDays,
        riExpireDays,
        integratedDays
      }

      if (!this.validateParams(data)) {
        return
      }
      const res = await postSopFilterConfig(data)
      if (res.code === '0') {
        this.$message.success(this.$t('Sop.SaveSucceed'))
      }
    },
    validateParams(data) {
      const { seExpireDays, aeExpireDays, aiExpireDays, siExpireDays, reExpireDays, integratedDays, jobState, riExpireDays } = data
      if (!seExpireDays || !aeExpireDays || !aiExpireDays || !siExpireDays || !reExpireDays || !integratedDays || !riExpireDays) {
        this.$message.warning(this.$t('Sop.SopFilterContent.PleaseInputDays'))
        return false
      }
      if (!jobState) {
        this.$message.warning(this.$t('Sop.SopFilterContent.PleaseSelectBusinessType'))
        return false
      }
      return true
    }
  }
}

</script>

<style lang="scss">
.tab-title {
  margin-top: 10px;
  margin-bottom: 17px;
}
.checkbox-group {
  padding: 17px 23px;
  border-bottom: 1px solid #E6E7EB;

}
.date-wrapper {
  padding-top: 9px;
  &>div:nth-child(1) {
    margin-top: 9px;
  }
  &>div {
    padding-left: 25px;
    margin-bottom: 10px;
  }
  span {
    display: inline-block;
    width:200px;
  }
  .el-input {
    width: 62px;
    height: 30px;
    margin: 0 5px;
    text-align: right;
  }
  .el-input--mini .el-input__inner {
    height: 30px;
    line-height: 30px;
  }
}
</style>
